import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=f6bb091e&"
import script from "./documents.vue?vue&type=script&lang=js&"
export * from "./documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports